webpackJsonp([136319575595514],{

/***/ 1399:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"3 Lessons from ‘Do What Works: The Diversity & Inclusion Guide for Excellence’","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/3-lessons-from-do-what-works-the-diversity-and-inclusion-guide-for-excellence","createdAt":"2017-10-28T00:15:35.928Z","blogAuthor":{"fields":{"name":"Morgan Nomura","slug":"blog/author/morgan-nomura"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/2B8RS5fWBmkoIuIKaYakyq/d4e35592ed66a923dfeee61861d35194/blog-post-blog-3-lessons-from-do-what-works-the-diversity-and-inclusion-guide-for-excellence.jpg"}}}}}]},"authorJson":{"name":"Morgan Nomura","slug":"blog/author/morgan-nomura","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/morgan-nomura"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-morgan-nomura-ba756ee52f2f1a5bd20a.js